import type { ReactNode } from "react";
import { cn } from "./ui/cn";

export function StatTile({
  label,
  value,
  sub,
  icon,
  tone = "neutral",
  hero,
}: {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  icon?: ReactNode;
  tone?: "neutral" | "critical" | "good";
  hero?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-col gap-1 rounded-lg border bg-surface px-4 py-3",
        tone === "critical" ? "border-critical/50 bg-critical-wash" : "border-line",
      )}
    >
      <div className="flex items-center gap-1.5 text-[13px] text-ink-2">
        {icon}
        <span className="truncate">{label}</span>
      </div>
      <div className={cn("font-semibold tracking-tight text-ink", hero ? "text-3xl" : "text-2xl")}>{value}</div>
      {sub && <div className="truncate text-xs text-ink-3">{sub}</div>}
    </div>
  );
}
